import { render, staticRenderFns } from "./TableTaxTM.vue?vue&type=template&id=b3b65212&scoped=true"
import script from "./TableTaxTM.vue?vue&type=script&lang=js"
export * from "./TableTaxTM.vue?vue&type=script&lang=js"
import style0 from "./TableTaxTM.vue?vue&type=style&index=0&id=b3b65212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b65212",
  null
  
)

export default component.exports